package com.appcreator.compose.components

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.appcreator.blueprint.core.Component
import com.appcreator.compose.di.Container

@Composable
actual fun ComponentComposable(modifier: Modifier, component: Component) {
    val modifierProvider = LocalComponentModifierProvider.current
    modifierProvider.Wrap(modifier, component) {
        Container.componentRegistry[component::class]?.invoke(it, component) ?: run {
            println("----- No component registered for ${component::class} -----")
        }
    }
}
